import React from 'react';
import { TableCheckBoxTemplate } from 'themes/components';

function TableCheckBox(props) {
	let tableCheckboxProps = {
		dataItem: props.item,
		field: props.column.key,
		onClick: props.column.onClick,
	};

	return (
		<TableCheckBoxTemplate {...tableCheckboxProps} className={props.column.className ? props.column.className : ''} />
	);
}

export default TableCheckBox;



// WEBPACK FOOTER //
// ./src/core/components/table/TableCheckBox.jsx